import { Meta } from '@storybook/addon-docs';
import { TokensGrid } from '../../components/TokensGrid';
import { radii } from '@rocketseat-ignite-ui/tokens';

<Meta title='Tokens/Radii' />

# Radii

<TokensGrid tokens={radii} />
